export default "__VITE_ASSET__aW8b7CmC__"